import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
const SECTIONS = [{
  id: 'overview',
  label: 'Overview'
}, {
  id: 'prerequisites',
  label: 'Before You Start'
}, {
  id: 'developer-centre',
  label: 'Step 1 — Developer Centre'
}, {
  id: 'register-key',
  label: 'Step 2 — Register for a Key'
}, {
  id: 'create-secret',
  label: 'Step 3 — Create Your Secret'
}, {
  id: 'account-number',
  label: 'Step 4 — Account Number'
}, {
  id: 'enter-corkship',
  label: 'Step 5 — Enter in CorkShip'
}, {
  id: 'troubleshooting',
  label: 'Troubleshooting'
}];
function StepBadge({
  n
}: {
  n: number;
}) {
  return <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-[#0284C7] text-white text-sm font-bold flex-shrink-0" data-id="element-89">{n}</span>;
}
function Callout({
  type,
  children
}: {
  type: 'info' | 'warning' | 'tip';
  children: React.ReactNode;
}) {
  const styles = {
    info: {
      bg: 'bg-[#EFF6FF]',
      border: 'border-[#0284C7]/30',
      icon: '💡',
      text: 'text-[#0369A1]'
    },
    warning: {
      bg: 'bg-[#FFFBEB]',
      border: 'border-[#F59E0B]/30',
      icon: '⚠️',
      text: 'text-[#92400E]'
    },
    tip: {
      bg: 'bg-[#F0FDF4]',
      border: 'border-[#10B981]/30',
      icon: '✓',
      text: 'text-[#065F46]'
    }
  }[type];
  return <div className={`${styles.bg} border ${styles.border} rounded-xl p-4 flex gap-3 my-5`} data-id="element-90">
      <span className="text-lg leading-tight flex-shrink-0" data-id="element-91">{styles.icon}</span>
      <p className={`text-sm leading-relaxed ${styles.text} m-0`} data-id="element-92">{children}</p>
    </div>;
}
function SectionHeading({
  id,
  children
}: {
  id: string;
  children: React.ReactNode;
}) {
  return <h2 id={id} className="font-heading text-2xl font-bold text-[#0F172A] mt-12 mb-6 pb-3 border-b border-[#E2E8F0] scroll-mt-24" data-id="element-93">{children}</h2>;
}
function SubHeading({
  children
}: {
  children: React.ReactNode;
}) {
  return <h3 className="font-heading text-lg font-bold text-[#0F172A] mt-8 mb-3" data-id="element-94">{children}</h3>;
}
function Step({
  n,
  title,
  children
}: {
  n: number;
  title: string;
  children: React.ReactNode;
}) {
  return <div className="flex gap-4 mb-6" data-id="element-95">
      <StepBadge n={n} data-id="element-96" />
      <div className="flex-1" data-id="element-97">
        <p className="font-semibold text-[#0F172A] text-[15px] mb-1" data-id="element-98">{title}</p>
        <div className="text-[#475569] text-[15px] leading-relaxed" data-id="element-99">{children}</div>
      </div>
    </div>;
}
function CredentialCard({
  label,
  example,
  description
}: {
  label: string;
  example: string;
  description: string;
}) {
  return <div className="border border-[#E2E8F0] rounded-xl overflow-hidden" data-id="element-100">
      <div className="bg-[#F8FAFC] px-4 py-3 flex items-center justify-between border-b border-[#E2E8F0]" data-id="element-101">
        <span className="font-semibold text-[#0F172A] text-sm" data-id="element-102">{label}</span>
        <span className="font-mono text-xs text-[#64748B] bg-white border border-[#E2E8F0] px-2.5 py-1 rounded-md" data-id="element-103">{example}</span>
      </div>
      <div className="px-4 py-3" data-id="element-104">
        <p className="text-[#475569] text-sm leading-relaxed" data-id="element-105">{description}</p>
      </div>
    </div>;
}
export function DocsAusPostCredentialsPage() {
  const [activeSection, setActiveSection] = useState('overview');
  useEffect(() => {
    const handleScroll = () => {
      for (const section of [...SECTIONS].reverse()) {
        const el = document.getElementById(section.id);
        if (el && el.getBoundingClientRect().top <= 120) {
          setActiveSection(section.id);
          break;
        }
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="min-h-screen flex flex-col bg-[#F1F5F9]" data-id="element-106">

      {/* Top Nav */}
      <header className="fixed top-0 left-0 right-0 z-[1000] bg-[#F1F5F9]/90 backdrop-blur-xl border-b border-[#0F172A]/[0.08]" data-id="element-107">
        <div className="flex items-center justify-between py-4 max-w-[1200px] mx-auto px-6" data-id="element-108">
          <Link to="/" className="flex items-center gap-2 font-heading text-xl font-bold text-[#0F172A] no-underline" data-id="element-109">
            <img src="https://assets.corkship.io/CorkShip%20Logo%20Original%20png.png" alt="CorkShip" className="w-8 h-8 object-contain" data-id="element-110" />
            CorkShip
          </Link>
          <div className="hidden md:flex items-center gap-3 text-sm" data-id="element-111">
            <Link to="/docs/commerce7" className="text-[#64748B] hover:text-[#0F172A] no-underline transition-colors" data-id="element-112">Commerce7 Docs</Link>
            <span className="text-[#E2E8F0]" data-id="element-113">·</span>
            <span className="inline-flex items-center gap-1.5 bg-[#FCD34D]/20 text-[#92400E] px-3 py-1 rounded-full text-xs font-semibold" data-id="element-114">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-3.5 h-3.5" data-id="element-115"><rect x="3" y="11" width="18" height="11" rx="2" ry="2" data-id="element-116" /><path d="M7 11V7a5 5 0 0 1 10 0v4" data-id="element-117" /></svg>
              Australia Post
            </span>
            Credentials Guide
          </div>
        </div>
      </header>

      {/* Hero */}
      <div className="pt-[80px] bg-[#0F172A] text-white" data-id="element-118">
        <div className="max-w-[1200px] mx-auto px-6 py-12" data-id="element-119">
          <div className="flex items-center gap-2 text-sm text-white/50 mb-4 flex-wrap" data-id="element-120">
            <Link to="/" className="text-white/50 hover:text-white no-underline transition-colors" data-id="element-121">CorkShip</Link>
            <span data-id="element-122">/</span>
            <span className="text-white/80" data-id="element-123">Documentation</span>
            <span data-id="element-124">/</span>
            <span className="text-white" data-id="element-125">Australia Post Credentials</span>
          </div>
          <div className="flex items-start justify-between gap-8 flex-wrap" data-id="element-126">
            <div data-id="element-127">
              <div className="inline-flex items-center gap-2 bg-[#FCD34D]/20 text-[#FCD34D] px-3 py-1.5 rounded-full text-xs font-semibold mb-4" data-id="element-128">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-3.5 h-3.5" data-id="element-129"><rect x="3" y="11" width="18" height="11" rx="2" ry="2" data-id="element-130" /><path d="M7 11V7a5 5 0 0 1 10 0v4" data-id="element-131" /></svg>
                Australia Post · API Credentials
              </div>
              <h1 className="font-heading text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-132">Getting Your Australia Post API Credentials</h1>
              <p className="text-white/70 text-lg max-w-[560px] leading-relaxed" data-id="element-133">How to find your API Key, API Secret, and Account Number from the Australia Post Developer Centre — required for both Shopify and Commerce7 versions of CorkShip.</p>
            </div>
            <div className="flex flex-col gap-3 text-sm" data-id="element-134">
              <div className="flex items-center gap-2 text-white/60" data-id="element-135">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4 flex-shrink-0" data-id="element-136"><circle cx="12" cy="12" r="10" data-id="element-137" /><path d="M12 6v6l4 2" data-id="element-138" /></svg>
                ~10 min setup
              </div>
              <div className="flex items-center gap-2 text-white/60" data-id="element-139">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4 flex-shrink-0" data-id="element-140"><path d="M20 7H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z" data-id="element-141" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" data-id="element-142" /></svg>
                eParcel contract required
              </div>
              <div className="flex items-center gap-2 text-white/60" data-id="element-143">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4 flex-shrink-0" data-id="element-144"><circle cx="12" cy="12" r="10" data-id="element-145" /><polyline points="12 8 12 12 14 14" data-id="element-146" /></svg>
                Approval within ~24 hours
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Layout */}
      <div className="flex-1 max-w-[1200px] mx-auto px-6 py-10 w-full" data-id="element-147">
        <div className="flex gap-10 items-start" data-id="element-148">

          {/* Sidebar */}
          <aside className="hidden lg:block w-56 flex-shrink-0 sticky top-24" data-id="element-149">
            <p className="text-xs font-semibold text-[#64748B] uppercase tracking-wider mb-3" data-id="element-150">On This Page</p>
            <nav className="flex flex-col gap-0.5" data-id="element-151">
              {SECTIONS.map(s => <a key={s.id} href={`#${s.id}`} className={`text-sm px-3 py-2 rounded-lg no-underline transition-colors ${activeSection === s.id ? 'bg-[#0284C7]/10 text-[#0284C7] font-semibold' : 'text-[#64748B] hover:text-[#0F172A] hover:bg-white'}`} data-id="element-152">
                  {s.label}
                </a>)}
            </nav>
            <div className="mt-6 p-4 bg-white rounded-xl border border-[#E2E8F0]" data-id="element-153">
              <p className="text-xs font-semibold text-[#0F172A] mb-1" data-id="element-154">Also see</p>
              <Link to="/docs/commerce7" className="text-xs text-[#0284C7] no-underline hover:underline block" data-id="element-155">Commerce7 setup guide →</Link>
            </div>
            <div className="mt-3 p-4 bg-white rounded-xl border border-[#E2E8F0]" data-id="element-156">
              <p className="text-xs font-semibold text-[#0F172A] mb-2" data-id="element-157">Need help?</p>
              <a href="mailto:support@corkship.io" className="text-xs text-[#0284C7] no-underline hover:underline" data-id="element-158">support@corkship.io</a>
            </div>
          </aside>

          {/* Content */}
          <main className="flex-1 min-w-0" data-id="element-159">
            <div className="bg-white rounded-2xl shadow-sm border border-[#E2E8F0] p-8 md:p-10" data-id="element-160">

              {/* Overview */}
              <SectionHeading id="overview" data-id="element-161">Overview</SectionHeading>
              <p className="text-[#475569] leading-relaxed mb-6" data-id="element-162">
                CorkShip connects directly to your Australia Post eParcel account to create shipments, generate labels, and close manifests. To do this it needs three credentials, all of which come from the <strong data-id="element-163">Australia Post Developer Centre</strong>.
              </p>
              <div className="flex flex-col gap-3 mb-6" data-id="element-164">
                <CredentialCard label="API Key" example="f62e0ab6-9ca7-4db8…" description="A UUID-format string that identifies your application. Generated once when you register on the Developer Centre — you receive it via email." data-id="element-165" />
                <CredentialCard label="API Secret" example="zV04N0fm4VDJ30zz…" description="Your API password. Unlike the Key, you create this yourself inside the Developer Centre Projects tab. You set the value and it is shown only once — save it immediately." data-id="element-166" />
                <CredentialCard label="Account Number" example="0002003242159" description="Your 10-digit eParcel contract account number, zero-padded on the left. This comes from your eParcel contract, not the Developer Centre." data-id="element-167" />
              </div>
              <Callout type="info" data-id="element-168">
                These credentials apply to both the <strong data-id="element-169">Shopify</strong> and <strong data-id="element-170">Commerce7</strong> versions of CorkShip. If you already have them set up in one platform, use the same credentials for the other.
              </Callout>

              {/* Prerequisites */}
              <SectionHeading id="prerequisites" data-id="element-171">Before You Start</SectionHeading>
              <p className="text-[#475569] leading-relaxed mb-4" data-id="element-172">You need two things before you can get API credentials:</p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6" data-id="element-173">
                {[{
                icon: '📦',
                title: 'An active eParcel contract',
                desc: 'The Shipping & Tracking API is only available to eParcel contract customers. If you don\'t have a contract yet, visit auspost.com.au/business/shipping/eparcel-contract or call 13 76 78 to apply.'
              }, {
                icon: '📧',
                title: 'An Australia Post account',
                desc: 'You\'ll need an account on the Australia Post Developer Centre (developers.auspost.com.au) linked to the same email as your eParcel contract. If you have a MyPost account, use those credentials.'
              }].map(item => <div key={item.title} className="flex gap-3 p-4 bg-[#F8FAFC] rounded-xl border border-[#E2E8F0]" data-id="element-174">
                    <span className="text-2xl flex-shrink-0" data-id="element-175">{item.icon}</span>
                    <div data-id="element-176">
                      <p className="font-semibold text-[#0F172A] text-sm mb-1" data-id="element-177">{item.title}</p>
                      <p className="text-[#64748B] text-sm leading-relaxed" data-id="element-178">{item.desc}</p>
                    </div>
                  </div>)}
              </div>
              <Callout type="warning" data-id="element-179">
                You must sign in to the Developer Centre with the <strong data-id="element-180">same Australia Post account that is linked to your eParcel contract</strong>. If the accounts don't match, Australia Post will prompt you to log in again with the correct one.
              </Callout>

              {/* Step 1 — Developer Centre */}
              <SectionHeading id="developer-centre" data-id="element-181">Step 1 — Log In to the Developer Centre</SectionHeading>
              <p className="text-[#475569] leading-relaxed mb-6" data-id="element-182">
                Go to <a href="https://developers.auspost.com.au" target="_blank" rel="noopener noreferrer" className="text-[#0284C7] no-underline hover:underline font-medium" data-id="element-183">developers.auspost.com.au</a> and sign in. If this is your first visit, create an account using the same email address associated with your eParcel contract.
              </p>
              <Callout type="tip" data-id="element-184">If you already have a MyPost or auspost.com.au account, use those same credentials — you don't need to create a new one.</Callout>

              {/* Step 2 — Register */}
              <SectionHeading id="register-key" data-id="element-185">Step 2 — Register for a Shipping &amp; Tracking API Key</SectionHeading>
              <p className="text-[#475569] leading-relaxed mb-6" data-id="element-186">
                Once logged in, you need to register your eParcel account to get an API Key. This is a one-time process — you'll receive your Key via email within approximately 24 hours.
              </p>
              <Step n={1} title="Click 'Register for a key' under Shipping & Tracking" data-id="element-187">
                On the Developer Centre home page, find the <strong data-id="element-188">Shipping &amp; Tracking</strong> section and click <strong data-id="element-189">Register for a key</strong> (or <strong data-id="element-190">Register your interest today</strong>).
              </Step>
              <Step n={2} title="Enter your eParcel account number" data-id="element-191">
                Fill in the registration form with your name, company name, and contact details. When asked for your account number, enter your <strong data-id="element-192">eParcel account number</strong> (last 7 digits only at this stage — Australia Post zero-pads it internally).
              </Step>
              <Step n={3} title="Select CorkShip as your Platform Partner" data-id="element-193">
                When asked <em data-id="element-194">"Are you accessing the API via a Platform Partner?"</em>, select <strong data-id="element-195">Yes</strong> and choose <strong data-id="element-196">CorkShip</strong> from the dropdown list.
              </Step>
              <Step n={4} title="Select your state and submit" data-id="element-197">
                Choose the Australian state where you handle your billing, then click <strong data-id="element-198">Send</strong>.
              </Step>
              <Callout type="info" data-id="element-199">
                Australia Post typically processes registrations within 24 hours. You'll receive an email with your <strong data-id="element-200">API Key</strong> and instructions. If you haven't heard back within 2 business days, email <a href="mailto:partners@auspost.com.au" className="text-[#0284C7] no-underline hover:underline" data-id="element-201">partners@auspost.com.au</a>.
              </Callout>

              {/* Step 3 — Secret */}
              <SectionHeading id="create-secret" data-id="element-202">Step 3 — Create Your API Secret</SectionHeading>
              <p className="text-[#475569] leading-relaxed mb-4" data-id="element-203">
                Unlike the API Key (which Australia Post issues to you), the <strong data-id="element-204">API Secret is a password you create yourself</strong> inside the Developer Centre. You choose the value.
              </p>
              <Callout type="warning" data-id="element-205">
                The API Secret is shown <strong data-id="element-206">only once</strong> at the time you create it. Copy it immediately and store it somewhere safe — you cannot retrieve it again. If you lose it, you'll need to create a new one.
              </Callout>
              <Step n={1} title="Log in to the Developer Centre and go to the Projects tab" data-id="element-207">
                Once you've accepted your invitation email and logged in, select the <strong data-id="element-208">Projects</strong> tab from the left-hand menu.
              </Step>
              <Step n={2} title="Create a new API Key" data-id="element-209">
                Click <strong data-id="element-210">Create API Key</strong>. Give your project a name (alphanumeric characters only) and select your organisation from the dropdown.
              </Step>
              <Step n={3} title="Set your secret" data-id="element-211">
                Give your key a nickname and enter a <strong data-id="element-212">secret</strong> — this is your chosen API password. Use something strong and unique. Click <strong data-id="element-213">Create key</strong>.
              </Step>
              <Step n={4} title="Copy and save your secret immediately" data-id="element-214">
                Your secret is displayed once on screen. Copy it now and store it securely — in a password manager or your notes. You will not be able to view it again.
              </Step>

              {/* Step 4 — Account Number */}
              <SectionHeading id="account-number" data-id="element-215">Step 4 — Find Your Account Number</SectionHeading>
              <p className="text-[#475569] leading-relaxed mb-4" data-id="element-216">
                Your Account Number is your eParcel contract account number. It does not come from the Developer Centre — it comes from your eParcel contract documents or the eParcel portal.
              </p>
              <SubHeading data-id="element-217">Where to find it</SubHeading>
              <div className="flex flex-col gap-3 mb-6" data-id="element-218">
                {[{
                source: 'eParcel contract document',
                detail: 'Your Australia Post account manager will have issued a contract document when you signed up. The account number appears on the first page.'
              }, {
                source: 'eParcel portal',
                detail: 'Log in to the eParcel portal (auspost.com.au/business/shipping/eparcel-contract) → go to Parcel Send → your account number appears next to your account name in the top corner.'
              }, {
                source: 'Your Australia Post account manager',
                detail: 'If you can\'t find it, call 13 76 78 or contact your dedicated account manager — they can confirm the number immediately.'
              }].map(item => <div key={item.source} className="flex gap-3 p-4 bg-[#F8FAFC] rounded-xl border border-[#E2E8F0]" data-id="element-219">
                    <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-[#0284C7]/10 text-[#0284C7] flex-shrink-0 mt-0.5" data-id="element-220">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="w-3 h-3" data-id="element-221"><polyline points="20 6 9 17 4 12" data-id="element-222" /></svg>
                    </span>
                    <div data-id="element-223">
                      <p className="font-semibold text-[#0F172A] text-sm mb-0.5" data-id="element-224">{item.source}</p>
                      <p className="text-[#64748B] text-sm leading-relaxed" data-id="element-225">{item.detail}</p>
                    </div>
                  </div>)}
              </div>
              <SubHeading data-id="element-226">Format — zero-padding is important</SubHeading>
              <p className="text-[#475569] leading-relaxed mb-4" data-id="element-227">
                Australia Post account numbers are <strong data-id="element-228">10 digits</strong>, zero-padded on the left. If your account number appears shorter on your contract, add leading zeros until it is 10 digits long.
              </p>
              <div className="bg-[#F8FAFC] border border-[#E2E8F0] rounded-xl overflow-hidden mb-6" data-id="element-229">
                <table className="w-full text-sm" data-id="element-230">
                  <thead data-id="element-231">
                    <tr className="border-b border-[#E2E8F0]" data-id="element-232">
                      <th className="text-left px-4 py-3 font-semibold text-[#0F172A]" data-id="element-233">On your contract</th>
                      <th className="text-left px-4 py-3 font-semibold text-[#0F172A]" data-id="element-234">Enter in CorkShip</th>
                    </tr>
                  </thead>
                  <tbody data-id="element-235">
                    {[{
                    contract: '1234567',
                    corkship: '0001234567'
                  }, {
                    contract: '12345678',
                    corkship: '0012345678'
                  }, {
                    contract: '2003242159',
                    corkship: '2003242159'
                  }].map(row => <tr key={row.contract} className="border-b border-[#E2E8F0] last:border-0" data-id="element-236">
                        <td className="px-4 py-3 font-mono text-[#475569]" data-id="element-237">{row.contract}</td>
                        <td className="px-4 py-3 font-mono text-[#0F172A] font-semibold" data-id="element-238">{row.corkship}</td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
              <Callout type="warning" data-id="element-239">
                Using the wrong number of digits will cause all shipment creation attempts to fail. If you're getting authentication errors after entering your credentials, check this first.
              </Callout>

              {/* Step 5 — Enter in CorkShip */}
              <SectionHeading id="enter-corkship" data-id="element-240">Step 5 — Enter Your Credentials in CorkShip</SectionHeading>
              <p className="text-[#475569] leading-relaxed mb-6" data-id="element-241">
                Once you have all three credentials ready, enter them in CorkShip.
              </p>
              <Step n={1} title="Open CorkShip and go to Settings" data-id="element-242">
                In your Commerce7 admin sidebar, click <strong data-id="element-243">CorkShip</strong>, then navigate to <strong data-id="element-244">Settings → Australia Post Credentials</strong>. For Shopify, open CorkShip from your Shopify admin apps list and go to Settings.
              </Step>
              <Step n={2} title="Enter all three credentials" data-id="element-245">
                Paste in your <strong data-id="element-246">API Key</strong>, <strong data-id="element-247">API Secret</strong>, and <strong data-id="element-248">Account Number</strong> (10 digits, zero-padded). Double-check for any leading or trailing spaces — copy-paste errors are the most common cause of authentication failures.
              </Step>
              <Step n={3} title="Toggle Production Mode on" data-id="element-249">
                In Settings, ensure <strong data-id="element-250">Production Mode</strong> is switched <strong data-id="element-251">on</strong> before creating real shipments. If you're still testing, leave it off — sandbox mode uses the Australia Post test environment and won't generate real labels or charges.
              </Step>
              <Step n={4} title="Save and verify" data-id="element-252">
                Click <strong data-id="element-253">Save</strong>. CorkShip will immediately test the connection to Australia Post. A green confirmation means you're connected. If you see an error, check the troubleshooting section below.
              </Step>
              <Callout type="tip" data-id="element-254">
                Your credentials are encrypted at rest and never shared with third parties. CorkShip stores only what's needed to authenticate with Australia Post on your behalf.
              </Callout>

              {/* Troubleshooting */}
              <SectionHeading id="troubleshooting" data-id="element-255">Troubleshooting</SectionHeading>
              {[{
              q: 'Authentication failed — credentials rejected',
              a: 'Double-check all three fields for copy-paste errors (no extra spaces, no truncation). Confirm your Account Number is exactly 10 digits with leading zeros. Check that Production Mode matches your credentials — sandbox keys only work with Production Mode off, live keys only with it on.'
            }, {
              q: "I can't find CorkShip in the Platform Partner dropdown",
              a: 'CorkShip may not yet appear in all regions\' dropdowns. If you can\'t find it, select the closest alternative or leave blank, then email support@corkship.io with your registration confirmation and we\'ll assist from there.'
            }, {
              q: "It's been more than 24 hours and I haven't received my API Key",
              a: 'Check your spam folder first. If it\'s still missing, email partners@auspost.com.au referencing your registration and they\'ll resend the invite. Make sure you registered using the email address linked to your eParcel contract.'
            }, {
              q: "I've lost my API Secret",
              a: 'The API Secret cannot be retrieved once created. You\'ll need to create a new one: log in to the Developer Centre → Projects → find your project → Create a new key with a new secret. Update the secret in CorkShip Settings immediately after.'
            }, {
              q: "I don't have an eParcel contract yet",
              a: 'The Shipping & Tracking API is only available to eParcel contract customers. Visit auspost.com.au/business/shipping/eparcel-contract or call 13 76 78 to apply. Approval typically takes 2–5 business days.'
            }].map(item => <div key={item.q} className="mb-5 border border-[#E2E8F0] rounded-xl overflow-hidden" data-id="element-256">
                  <div className="flex items-start gap-3 p-4 bg-[#F8FAFC]" data-id="element-257">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4 text-[#0284C7] flex-shrink-0 mt-0.5" data-id="element-258"><circle cx="12" cy="12" r="10" data-id="element-259" /><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" data-id="element-260" /><line x1="12" y1="17" x2="12.01" y2="17" data-id="element-261" /></svg>
                    <p className="font-semibold text-[#0F172A] text-sm" data-id="element-262">{item.q}</p>
                  </div>
                  <div className="p-4" data-id="element-263">
                    <p className="text-[#475569] text-sm leading-relaxed" data-id="element-264">{item.a}</p>
                  </div>
                </div>)}

              <div className="mt-10 p-6 bg-[#0F172A] rounded-2xl text-center" data-id="element-265">
                <p className="font-heading text-lg font-bold text-white mb-2" data-id="element-266">Still stuck?</p>
                <p className="text-white/60 text-sm mb-4" data-id="element-267">We're happy to help. Reach out and we'll get back to you within one business day.</p>
                <a href="mailto:support@corkship.io" className="inline-flex items-center gap-2 bg-[#0284C7] text-white px-6 py-2.5 rounded-lg text-sm font-semibold no-underline hover:bg-[#0369A1] transition-colors" data-id="element-268">Email Support</a>
              </div>

            </div>
          </main>
        </div>
      </div>

      <Footer data-id="element-269" />
    </div>;
}